import styled from "styled-components";

export const ToolbarContainer = styled.div`
  padding: 48px;
  display: grid;
  align-items: center;
  justify-items: center;
  grid-template-columns: repeat(3, 1fr);
  column-gap: 10px;

  * {
    font-family: "PP Formula";
  }

  & > :nth-child(1) {
    justify-self: flex-start;
  }
  & > :nth-child(2) {
    justify-self: center;
  }
  & > :nth-child(3) {
    justify-self: flex-end;
  }
`;

export const ColumnsContainer = styled.div`
  display: grid;
  grid-template-columns: ${({ numberOfColumns }) =>
    `repeat(${numberOfColumns}, 1fr)`};
  gap: 20px;
`;

export const ColumnContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(${({ columns }) => columns}, 1fr);
  gap: 4px;
  width: 32px;
  height: 17px;
  cursor: pointer;
`;

export const Column = styled.div`
  border-radius: 4px;
  background-color: ${({ active, theme }) =>
    active ? `${theme.bg.brand}80` : theme.border.black15};
  width: 100%;
  height: 100%;
  border: 1px solid
    ${({ active, theme }) => (active ? `${theme.bg.brand}80` : "transparent")};

  ${({ active }) =>
    active && `box-shadow: 0px 1px 5px 0px rgba(0, 175, 255, 0.36);`};
`;

export const GroupCardsButton = styled.div`
  border-radius: 9999px;
  border: 0.5px dashed ${({ theme }) => theme.border.black50};
  padding: 4px 10px;
  font-size: 12px;
  color: ${({ theme }) => theme.border.black50};
  cursor: pointer;
  background-color: transparent;
  transition: background-color ease 0.1s, color ease 0.1s;
  display: grid;
  place-content: center;
  height: 28px;
  box-sizing: border-box;

  &:hover {
    background-color: ${({ theme }) => theme.text.brand}33;
  }
`;
